import { SolAvatarSize, SolViewId, SolViewOptions } from '@sol/components';
import { NotesPermissions } from './note.model';

/** `summary` is the Notes row: "No notes" when empty, else nothing. `list` is the notes under it, full width. */
export type NotesViewPart = 'summary' | 'list';

/** Options of the Notes read view. */
export interface NotesViewOptions extends SolViewOptions {
  part: NotesViewPart;
  /** `small` in a panel, `default` on a page. */
  size: SolAvatarSize;
  /** The page's own date format (`NAM04`). */
  dateFormat: string;
  permissions: NotesPermissions;
  /** Show every note instead of the newest three; owned by the surface's state. */
  expanded: boolean;
}

export class NotesViewId {
  public static readonly notes = SolViewId.of<NotesViewOptions>('annotationNotes.notes', {
    part: 'summary',
    size: 'default',
    dateFormat: 'yyyy-MM-dd HH:mm',
    permissions: { userId: '', canWrite: false, canDeleteAny: false },
    expanded: false,
  });
}
